module.exports = __webpack_public_path__ + "img/forex-trading-background_52683-42357.87868717.png";